import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";

function HasPermission(name: Permissions | Array<string>, ignore?: boolean): boolean {
    const { permissions, role } = usePermissions();
    if (role?.defaultRole) {
        return true;
    }

    if (ignore) {
        return true;
    }

    if (Array.isArray(name)) {
        return name.some((item) => permissions.includes(item));
    }

    return permissions.includes(name);
}

export default HasPermission;
